import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {connect} from 'react-redux';
import NotFound from '../../Pages/NotFound';
import Spinner from '../../SmallLayoutComponents/FullPageSpinner';

const PrivateRoute = ({component: Component, loggedIn, loadingUser, ...rest}) => (
    <Route
        {...rest}
        render={(props) =>
            loggedIn === true ? (
                <Component {...props} />
            ) : (
                <>
                    {loadingUser ? (
                        <Spinner />
                    ) : (
                        <>
                            {loggedIn ? (
                                <NotFound />
                            ) : (
                                <Redirect
                                    to={{
                                        pathname: '/login',
                                        state: {from: props.location},
                                    }}
                                />
                            )}
                        </>
                    )}
                </>
            )
        }
    />
);

const mapStateToProps = (state) => {
    return {
        loggedIn: state.user.loggedIn,
        loadingUser: state.user.loading,
    };
};

export default connect(mapStateToProps)(PrivateRoute);
